import { soapActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  patientEncouterDetail: null,
  saved_patientEncounter: null,
  appointment: null,
  clockin_time: null,
  clockout_time: null,
  master_data: [],
};


export default (state = initialState, { type, payload }) => {
  switch (type) {
  case soapActionTypes.get_masterdata.REQUEST:
  case soapActionTypes.get_appointment_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      appointment: null,
    };
  case soapActionTypes.get_appointment_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment: payload,
    };
  case soapActionTypes.get_patient_encounter.REQUEST:
    return {
      ...state,
      loading: true,
      patientEncouterDetail: null,
    };
  case soapActionTypes.get_patient_encounter.SUCCESS:
    return {
      ...state,
      loading: false,
      patientEncouterDetail: payload,
    };
  case soapActionTypes.post_patient_encounter.REQUEST:
    return {
      ...state,
      loading: true,
      saved_patientEncounter: null,
    };
  case soapActionTypes.post_patient_encounter.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_patientEncounter: payload,
    };
  case soapActionTypes.post_clockin_time.REQUEST:
    return {
      ...state,
      loading: false,
    };
  case soapActionTypes.post_clockin_time.SUCCESS:
    return {
      ...state,
      loading: false,
      clockin_time: payload,
    };
  case soapActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case soapActionTypes.post_clockout_time.REQUEST:
    return {
      ...state,
      loading: false,
    };
  case soapActionTypes.post_clockout_time.SUCCESS:
    return {
      ...state,
      loading: false,
      clockout_time: payload,
    };
  default:
    return state;
  }

};




// WEBPACK FOOTER //
// ./src/modules/scheduling/components/nonBillableSoap/reducers/soapReducer.js